import "./form.scss";
import { CiSearch } from "react-icons/ci";
import { userPlaceholder } from "assets/icons";
import React, { forwardRef } from "react";
import Select from "react-select";
import moment from "moment";
import { Button } from "@mui/material";
// ****************** Search box **************************//

export const SearchBar = ({ className, placeholder, ...rest }) => {
  return (
    <>
      <div className={`search_bar ${className}`}>
        <CiSearch />
        <input
          type="search"
          className="form-control input"
          placeholder={placeholder}
          {...rest}
        />
      </div>
    </>
  );
};

// *********************** Button with icon *********************** //

export const IconButton = ({ children, className, button, ...rest }) => {
  return (
    <>
      <button
        type={button}
        className={`button icon_button ${className}`}
        {...rest}
      >
        {children}
      </button>
    </>
  );
};

// export const CustomButton = ({ children, className, ref, ...rest }) => {
//   return (
//     <>
//       <Button variant="contained" ref={ref} className={`button ${className}`} {...rest}>
//         {children}
//       </Button>
//     </>
//   );
// };
export const CustomButton = forwardRef(
  ({ children, className, isLoading, isDisabled, ...rest }, ref) => {
    return (
      <Button
        variant="contained"
        ref={ref} // Pass the ref here
        className={`button ${className}`}
        disabled={isLoading || isDisabled} // Disable button if loading
        {...rest}
      >
        {isLoading ? <span className="loader" /> : children}
      </Button>
    );
  }
);

export default CustomButton;

// *********************** Switch Button *********************** //

export const SwitchButton = ({
  className = "",
  status,
  onClick,
  readOnly = true,
}) => {
  return (
    <>
      <label className={`switch ${className}`}>
        <input
          type="checkbox"
          checked={status === "true" || status === true}
          readOnly={readOnly}
          onClick={onClick}
        />
        <span className="slider round"></span>
      </label>
    </>
  );
};

// Image //

export const Img = ({ src, alt }) => {
  const onImageError = (e) => {
    e.target.src = userPlaceholder;
  };
  return (
    <>
      <img src={src} alt={alt} onError={onImageError} />
    </>
  );
};

export const searchDateFormat = (date) => {
  // return date ? moment(date).format("DD-MM-yyyy") : ""
  return date ? moment(date).format("yyyy-MM-DD") : "";
};

export const MultiSelect = ({
  defaultValue,
  isMulti = true,
  Options = [],
  label = "",
  value,
  onChange,
  placeholder='Select'
}) => {
  return (
    <>
      <label htmlFor="email_address" className="label">
        {label}
      </label>
      <Select
      className="multi_select"
        closeMenuOnSelect={false}
        // components={animatedComponents}
        defaultValue={defaultValue}
        isMulti={isMulti}
        options={Options}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
      />
    </>
  );
};
